export default __webpack_public_path__ + "static/media/pic1.346c1ec6.jpg";